import React from "react";

import { useNavigate, Link } from "react-router-dom";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

export default function BoxProfilePicture(props) {
  const navigate = useNavigate();

  const openCustomersDetails = (e, customer) => {
    e.preventDefault();
    navigate(`/customers/${customer.id}`, { state: { title: customer.name } });
  }

  return (
    <div className="box no-bg">
      <div className="box-avatar-wrapper">
        <div className="box-avatar" style={{ backgroundImage: `url(${props.user.profile_pic})` }}></div>
      </div>
      {props.user && props.user.usadao_id != "" && (
        <span className="chat-user-id">#{props.user.usadao_id}</span>
      )}
      <span className="chat-user-username">{props.user.nickname}</span>
      <Link to={`/customers/${props.user.id}`} onClick={e => openCustomersDetails(e, props.user)} className="chat-user-name">{props.user && props.user.name}</Link>

      {props.user.dataAniversario && (
        <span className="chat-user-username">Idade: {props.user.year} anos</span>)
      }

      {props.user.ultimaVizualizacao && (
        <span className="chat-user-username">Ultimo login no leilão:</span>)}
      {props.user.ultimaVizualizacao && (
        <span className="chat-user-id">{moment(props.user.ultimaVizualizacao).format("LLL")}</span>)}

      {props.user.city_name && props.user.state_name && (
        <span className="chat-user-username">
          {props.user.city_name} ({props.user.state_name})
        </span>
      )}
    </div>
  );
}